import React, { useState, useEffect } from "react";
import { Table, Button, Col, Container, Row, DropdownButton, Dropdown  } from "react-bootstrap";
import { useLocation, useNavigate, Link } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
import { ShimmerTable } from "react-shimmer-effects";
import "react-toastify/dist/ReactToastify.css";
import {
    DatatableWrapper,
    Pagination,
    TableBody,
    TableHeader,
  } from "react-bs-datatable";

import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import PageNavigations from "../breadcrumbs/PageNavigations";
import AddBook from "./AddBook";
import { usePermissions } from "../contexts/PermissionContext";

const ViewLanguage = (props) => {

  const location = useLocation();
  const navigate = useNavigate();
  const [language, setLanguage] = useState(location.state ? location.state : {});
  const [body, setBody] = useState([]);
  const { rolePermissions, userInfo } = usePermissions();
  const canCreate = rolePermissions?.Book_List?.can_create


  const [modalShow, setModalShow] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('');


  const header = [
    { title: "S.No.", prop: "serial", isFilterable: true },
    { title: "Book", prop: "title", isFilterable: true, cell: (row) => (
        <Link to={"/books/" + row.id} state={row}>
          {row.title}
        </Link>
      ), },
    { title: "Book Number", prop: "isbn", isFilterable: true },
    { title: "Author", prop: "author_name", isFilterable: true },
    { title: "Category", prop: "category_name", isFilterable: true },
    { title: "Publisher", prop: "publisher_name", isFilterable: true },
    { title: "copies", prop: "total_copies", isFilterable: true }, 
    { title: "Available", prop: "available", isFilterable: true },
    { title: "Status", prop: "status" , isFilterable: true}, 
  ];
  
  async function initBook(languageId) {
    let result = await schoolApi.getBooksRecordsBylanguageId(languageId);

    if(result.success){
      setBody(result.book);
      setSelectedLanguage(languageId);
    } else {
      setBody([]);

    }  
  }

  const fetchlanguage = () => {
    if (location.hasOwnProperty("pathname")) {
      language.id = location.pathname.split("/")[2];
      setLanguage(language);
    }

    initBook(language.id);
  };
 
  useEffect(() => {
    fetchlanguage();
  }, []); 
  
  const handleBack = () => {
    navigate(`/language`);
  };  


  useEffect(()=>{
    async function fetchAllLanguages(){
      try{
        let res = await schoolApi.getLanguagesRecords();

        if(res.success){
          setLanguages(res.language);
        } else setLanguages([]);
      }catch(error){
        console.error('Error fetching categories:', error);
      }      
    }
    fetchAllLanguages();
  }, []);
  
  const handleSelectLanguage = async(languageId) =>{
    setSelectedLanguage(languageId);
    setLanguage({id: languageId});
  }
  
  useEffect(()=>{
    if(selectedLanguage){
      initBook(selectedLanguage);
    }
  },[selectedLanguage]);

  const addBook = () => {
    setModalShow(true);
  };

  const recordSaveSuccesfully = () => {
    setModalShow(false);
    initBook(language.id);
  };


  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <div>
        {body && (
          <Container>
         <PageNavigations
              listName="Language"
              listPath="/language"
              viewName=""
              viewPath=""
              colLg={2}
              colClassName="d-flex mx-3 mb-3"
              extrColumn={12}
            />
            <Row className="view-form pt-5">
              <Col lg={12}>
                <Row>
                  <Col lg={12}>
                    <Col className="mx-3">
                      <Col className="section-header my-3">
                        <span style={{ color: "black" }}>
                          LANGUAGE INFORMATION
                        </span>
                      </Col>
                    </Col>
                  </Col>
                </Row>
                <Row className="view-form-header align-items-center mx-3">
                  <Col lg={3}>
                    {}
                    <DropdownButton size="sm" id="dropdown-basic-button" variant="primary" title={selectedLanguage ? languages?.find(lang => lang.id === selectedLanguage)?.name: language?.name} onSelect={handleSelectLanguage} className='select-name-btn'>
                      {languages?.map(lang => (
                          <Dropdown.Item key={lang.id} eventKey={lang.id}>{lang.name}</Dropdown.Item>
                        ))}
                    </DropdownButton>
                  </Col>
                  <Col lg={9} className="d-flex justify-content-end">
                    {}
                    {(userInfo?.userrole === "SYS_ADMIN" || userInfo?.userrole === "ADMIN" || canCreate) &&
                      <Button
                      className="btn-sm mx-2"
                      variant="primary"
                      onClick={() => addBook(true)}
                    >
                      Add Book
                    </Button>}
 
                    <Button className="btn-sm mx-2" variant="danger" onClick={handleBack}>
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </Button>
                    <ToastContainer
                      position="top-right"
                      autoClose={2000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      theme="light"
                    />
                  </Col>
                </Row>
                <Row className="mx-3 mt-2">
                <div>
                    <DatatableWrapper body={body} headers={header}>
                        <Table striped className="data-table custom-table-subject-list">
                          <TableHeader />
                          {body.length > 0 ?  <TableBody /> : <TableBody><tr><td colSpan={9} className="text-center">No Records Found!!!</td></tr></TableBody>}
                        </Table>
                        <Pagination />
                    </DatatableWrapper>
                  </div>
                </Row>
                 <Row></Row>
               </Col>
            <Col></Col>
             </Row>
       </Container>)}
       {}
       {modalShow && (
        <AddBook
          show={modalShow}
          language={language.id}
          onHide={() => setModalShow(false)}
          recordSaveSuccesfully={recordSaveSuccesfully}
        />
         )}
       </div>
     </>
  );
};
export default ViewLanguage;